// it sure is lonely in here

export function removeValue(array, item) {
    let index;
    while(array.length > 0 && (index = array.indexOf(item)) >= 0)
        array.splice(index, 1);
};
